import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, normalizeStyle as _normalizeStyle, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, resolveComponent as _resolveComponent, vShow as _vShow, createVNode as _createVNode, withDirectives as _withDirectives, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-d2c7fd8e"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "fas fa-reply me-2" }, null, -1))
const _hoisted_2 = { class: "steps mt-3" }
const _hoisted_3 = { class: "progress" }
const _hoisted_4 = ["aria-valuenow"]
const _hoisted_5 = ["disabled", "onClick"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ProjectTabComponent = _resolveComponent("ProjectTabComponent")!
  const _component_BudgetTabComponent = _resolveComponent("BudgetTabComponent")!
  const _component_ApprovementTabComponent = _resolveComponent("ApprovementTabComponent")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("button", {
      class: "btn btn-secondary",
      type: "button",
      onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.backClick && _ctx.backClick(...args)))
    }, [
      _hoisted_1,
      _createTextVNode("ถอยกลับ ")
    ]),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", {
          class: "progress-bar",
          role: "progressbar",
          style: _normalizeStyle({ width: _ctx.navigator.percent + '%' }),
          "aria-valuenow": _ctx.navigator.percent,
          "aria-valuemin": "0",
          "aria-valuemax": "100"
        }, null, 12, _hoisted_4)
      ]),
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.navigator.items, (n, index) => {
        return (_openBlock(), _createElementBlock("div", {
          class: "step-item",
          key: n
        }, [
          _createElementVNode("button", {
            class: _normalizeClass(["step-button text-center", { active: index <= _ctx.navigator.current }]),
            disabled: index > _ctx.navigator.done,
            onClick: ($event: any) => (_ctx.selectClick(index))
          }, _toDisplayString(n), 11, _hoisted_5)
        ]))
      }), 128))
    ]),
    _withDirectives(_createVNode(_component_ProjectTabComponent, {
      project: _ctx.project,
      onNext: _ctx.toBudget
    }, null, 8, ["project", "onNext"]), [
      [_vShow, _ctx.navigator.current === 0]
    ]),
    _withDirectives(_createVNode(_component_BudgetTabComponent, {
      budgets: _ctx.budgets,
      onNext: _ctx.toApprovement
    }, null, 8, ["budgets", "onNext"]), [
      [_vShow, _ctx.navigator.current === 1]
    ]),
    _withDirectives(_createVNode(_component_ApprovementTabComponent, {
      approvement: _ctx.approvement,
      onSubmit: _ctx.toSubmit
    }, null, 8, ["approvement", "onSubmit"]), [
      [_vShow, _ctx.navigator.current === 2]
    ])
  ], 64))
}